<template>

<video muted playsinline autoplay loop :id="videoId">
  <source :src="require(`../../../assets/videos/${name}`)" type="video/mp4">
</video>

</template>

<script>
export default {
  name: 'BgVideo',
  props: {
    id: String,
    name: String
  },
  computed: {
    videoId: function() {
      return 'v-' + this.id
    }
  }
}
</script>

<style lang="scss" scoped>
video {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  object-fit: cover;
}
</style>
